import type { GroupChange } from '../../domain/grouping.types';
import type { GroupEditValues } from '../../domain/groupRules';
import type { GroupEditDraftValues } from './useGroupEditDraft';

/** Translates the edited values of a group into the single change applied on "Save changes". */
export function toEditGroupChange(
  groupId: string,
  original: GroupEditValues,
  draft: GroupEditDraftValues
): GroupChange {
  if (draft.deleteGroup) {
    return { groupId, type: 'delete' };
  }
  const name = draft.name.trim();
  return {
    addItemIds: draft.memberIds.filter(id => !original.memberIds.includes(id)),
    color: draft.color !== original.color ? draft.color : undefined,
    groupId,
    name: name !== original.name.trim() ? name : undefined,
    removeItemIds: original.memberIds.filter(id => !draft.memberIds.includes(id)),
    type: 'update'
  };
}
